export default {
  accepted_message: "投注成功!",
  login: "请登录访问更多内容...",
  password_rule: "密码区分大小写，长度必须为6到10个字符。",
  nickname_rule: "您可以为显示和登录设置昵称（6到15个字母或数字）。请注意，您只能将此昵称设置一次。一旦设置，您就无法修改或取消它。",
  change_password_succeed: "您已成功更改密码。",
  add_secondary_succeed: "您已成功添加昵称。",
  succeed: "您已成功完成操作！",
  failed: "你未能完成这个动作！",
  no_information_available: "无信息。",
  select_display_language: "选择您偏好的默认语言。",
  select_odds_type: "选择您偏好的默认赔率类型显示。",
  select_page_type: "选择您偏好的页面类型显示于今日及早盘页面。",
  select_show_score_map: "投注时系统将启用自动显示盈利预测图。",
  select_default_event_sorting: "选择您偏好的默认赛事排序显示。",
  select_market_type: "选择您偏好的默认盘口类型显示。",
  select_page_size: "选择首选页面大小。",
  change_sports_menu_order: "请拖拽运动来改变所需的体育赛事排序。",
  view_outstanding_bets_in_bet_list: "最新未完成投注可能需要一些时间处理，可至投注历史查询您的投注纪录。",
  time_display_in_gmt_plus_8: "显示时间为GMT+8时区",
  select_default_stake: "启用系统自动输入您自订的投注额及最后投注的投注额。",
  bet_empty: "您的投注单是空的。请点选画面上的赔率进行下注。",
  no_event: "当前没有可投注的赛事或游戏。您可先至其他运动或游戏进行下注，或稍后回来查看。",
  no_games_available: "暂无可用游戏。",
  no_bets: "没有任何进行中的投注",
  no_waiting: "没有任何等待中的投注",
  no_void: "没有任何作废的投注",
  odds_changed: "赔率变了，",
  gmt8: "显示时间为GMT+8时区。",
  no_betting_market: "当前无投注市场",
  note_1: "未决投注可能需要一些时间来处理。请转到“我的投注”查看您最新的未决投注。",
  match_not_started: "比赛尚未开始",

  banner1a: "PICK A SPORT",
  banner1b: "GET IN THE GAME",
  banner1c: "With a comprehensive selection of over 90 sports and thousands of live matches to bet on, the adrenalin rush never ends. Don’t miss out on your chance to win with our offer of only the best odds and top sports picks on the market.",
  banner2a: "ROLL THE DICE",
  banner2b: "HIT THE JACKPOT",
  banner2c: "Rake in winnings, all while enjoying a rich and immersive casino gaming experience at any of our luxurious suites. Take a seat, play your favourite casino game, and be on the receiving end of quality interaction from live dealers, all from the comfort of wherever you are.",
  banner3a: "GAMING AT ITS FINEST",
  banner3b: "A REVOLUTIONARY EXPERIENCE",
  banner3c: "An extensive selection of games, as far as the eye can see. Get a firsthand taste of it now.",
  banner4a: "OLYMPIC GAMES",
  banner4b: "TOKYO 2020",
  banner4c: "The 2020 Summer Olympics, officially the Games of the XXXII Olympiad and also known as Tokyo 2020, is an upcoming international multi-sport event scheduled to be held from 23 July to 8 August 2021 in Tokyo",
  banner4d: "We Bringing Back The EURO CUP 2020 For You!",
  banner5a: "LIVE SPORTS & GAME HIGHLIGHTS",
  banner5aa: "REACH YOUR COMMUNITY IN REAL TIME",
  banner5b: "Watch the best free Live TV and Highlights on the web and mobile devices",
  banner5c: "Get the latest sports scores anytime, anywhere",

  banner6a: "E-Fighting",
  banner6b: "Play the best fighting games",
  banner6c: "Collect your favorite characters, throw down in competitive combat, enter the battlefield and feel the fight! The more you play, the more you win!",

  banner7a: "NEW ESPORTS INTERFACE, ALL NEW EXPERIENCE",
  banner7b: "Extensive Choices of Esports markets, Industry Leading Betting Experience.",
  banner7c: "Popular massive multiplayer, Unbeatable odds & speedy settlement.",

  banner8a: "V-GAMES",
  banner8b: "PLAY THE GAMES, AND EXPERIENCE A DIFFERENT KIND OF VICTORY.",
  banner8c: "Experience a whole new level of victory.",
  banner8d: "Immerse yourself in a variety of games, from competitive to fighting, and explore new genres that wil keep you engaged for hours.",

  bannersb: "Enjoy non-stop thrills and excitement with an endless variety of sporting competitions to wager on, both locally and from all across the world. With us, you’ll always have the best odds.",
  bannersl: "Take a break from reality, step right through, and experience for yourself the fantasies that have been brought to life in our vividly detailed virtual games. You’re sure to get addicted. ",
  bannerlc: "Step inside any of our exclusive casino suites, indulge in your classic casino favourites, and lose yourself in an interactive experience featuring gorgeous live dealers.",

  banner10a: "Wishing you a great fun time",
  banner10b: "While you row to the rhythm of roaring drums!",
  
  banner11a: "世界最大的国家队锦标赛",
  banner11b: "2022年 世界杯将于 11 月 20日 至 2022 年 12 月 18 日 在卡塔尔举行",
  banner11c: "总共 32 支球队，包括主持国卡塔尔，有资格参加比赛，这将是第一次在中东举行最大的足球比赛。",

  join_us1: "MAKE THIS YOUR WORLD",
  join_us2: "With 24/7 action and a spectacular array of products to wager on, we cater to pretty much any and all types of preferences. Plus, we’ve got cool bonuses, ongoing promotions, and efficient payouts to ensure you enjoy the best gaming experience. Take the first step and sign up with us now. It’s quick, easy, and free.",
  join_us3: "JOIN US NOW",

  icon1a: "OPTIMIZED FOR MOBILE",
  icon1b: "Our games are accessible on popular mobile platforms, so you can game on the go on your favourite device",
  icon2a: "ADVANCED SECURITY & SUPPORT",
  icon2b: "Enjoy our games and transact with us with true peace of mind – our website is fully secure to safeguard your privacy and personal info",
  icon3a: "IMMERSIVE EXPERIENCE",
  icon3b: "Indulgent, intuitive, and interactive – we have curated and selectively chosen premium products that will deliver the excitement you seek",
  icon4a: "CUSTOMER SUPPORT",
  icon4b: "Your satisfaction is our priority. We would to hear from you should you have any feedback or queries that would help us serve you better",
  footer1a: "Underage Gambling",
  footer1b: "Gambling is illegal for kids under the age of 18. Every state prohibits gambling by minors.{fvalue} will carry out age verification randomly and winnings will be forfeited if the gambler is below 18 years old.© 2004-2019. {fvalue} is An Internationally Registered Trademark (Licensed Sports Bookmaker). All Rights Reserved.",
  contactus_title1: "客户服务专员可以回答您所有的问题，包括中英文付款问题。",
  contactus_title2: "您可能需要支付国际电话费。 我们会有通话记录，以提供客户保护，信息验证，质量保证和合规性。",

  days: "天",
  hours: "小时",
  mins: "分钟",
  secs: "秒",
  ldiff_changed: "Percent has changed",
  no_room: "没有可加入的房间。请选择其他选项并重新搜索或稍后再回来。",
  people_in_this_room: "人在这个房间",
  room_full: "此房间已满",
  room_joined: "您已成功加入房间",
  my_room: "我的房间",
  pin_code: "例如：123456",
  no_matches: "现在没有可选择的比赛或游戏。",
  are_you_sure: "您确定要执行此操作吗？",
  accept_terms: "勾选即表示您确认已阅读、理解并同意上述条款和条件。",
  accept_required: "在继续之前，请阅读、理解并同意<br />上述条款和条件。",
  must_accept_better_odds: "默认情况下，下注时将自动接受更好的赔率。请参阅条款和条件以获取更多信息。",
  maintenance_notice: "目前我们正在进行系统维护。请稍后再试。",
  not_winning_prize_in_this_tournament: "您在本次锦标赛中，没有获得任何奖项。",
  you_did_not_join_this_room: "您没有加入此房间。",
  deduct_confirm: "这将开始游戏并扣除您的信用点。<br/>您确定要继续吗？",
  over_max_match: "此联赛内的赛事超出最高可选择场次，<br />请展开联赛后选择所需的赛事。",

  //tournament
  button_skip: "Skip tour",
  button_previous: "Previous",
  button_next: "Next",
  button_stop: "Finish",
  button_continue: "Continue",
  tour_content_1: "<h6>欢迎来到 WBET 锦标赛</h6><p>我们很高兴地宣布一场专为我们网站支持者举办的激动人心的新锦标赛。</p>",
  tour_content_2: "<h6>公共房间</h6><p>成员之间进行竞争性游戏，通常需要支付入场费。</p>",
  tour_content_3: "<h6>私人房间</h6><p>会员可以使用邀请密码进入，打开房间与朋友一起玩。</p>",
  tour_content_4: "<h6>公共免费房间</h6><p>由各个组织在专门为会员举办的特别活动期间举办，提供免费参与。</p>",
  tour_content_5: "<h6>可以加入的玩家总数和费用</h6><p>玩家：房间的容量。</p><p>入场费：按房间报价计算（账户持有人的货币）。</p><p>入场费：按房间报价计算（账户持有人的货币）。 p>",
  tour_content_6: "<h6>房间详细信息</h6><p>点击此处预览房间静态信息并加入房间。</p>",
  tour_content_7: "<h6>彩池详细信息</h6><p>获胜者的彩池总奖金以及要搜索的唯一房间 ID。</p>",
  tour_content_8: "<h6>房间开始详细信息</h6><p>房间状态和上次加入时间显示。</p>",
  tour_content_9: "<h6>创建私人房间</h6><p>创建私人房间游戏并邀请朋友通过 pin 加入。</p>",
  tour_content_10: "<h6>积分排名</h6><p>此功能是为了显示积分，以便玩家查看和跟踪结果。</p>",

  time_machine_information_HDP: "WBET时光机【让球盘】玩法是预测主客球队在选定时段内进球更多。",
  time_machine_information_OU: "WBET时光机【大小盘】玩法是预测选择时间段内的总进球数。",

  cashoutSuccesfully: "实时兑现成功！"

};
